import { cva } from "class-variance-authority";

export const registrationFeedbackThankYouRootStyles = cva([
  "mx-auto box-border flex w-full min-w-0 max-w-full flex-col items-stretch gap-10 text-left",
  "md:max-w-[402px] md:items-center",
  "lg:max-w-[800px] lg:items-center lg:gap-12 lg:text-center",
]);

export const registrationFeedbackThankYouContentStyles = cva([
  "flex w-full min-w-0 max-w-full flex-col items-start gap-4",
  "lg:items-center lg:gap-6",
]);

export const registrationFeedbackThankYouCopyStyles = cva([
  "flex w-full min-w-0 max-w-full flex-col items-start gap-4",
  "lg:items-center",
]);

export const registrationFeedbackThankYouIconStyles = cva([
  "size-16 shrink-0",
  "lg:size-20",
]);

export const registrationFeedbackThankYouTitleStyles = cva([
  "m-0 w-full min-w-0 max-w-full break-words text-left font-[var(--Font-Family-large-title,Canela_Text),serif] text-[2.5rem] font-black leading-[1.2] text-[var(--Freedom-M3-sys-light-on-primary-fixed,#001E30)]",
  "lg:text-center",
]);

export const registrationFeedbackThankYouMessageStyles = cva([
  "m-0 w-full min-w-0 max-w-full break-words [overflow-wrap:anywhere] text-left font-[Poppins,sans-serif] text-sm font-medium leading-5 tracking-[0.1px] text-[#003049]",
  "lg:max-w-[690px] lg:text-center lg:text-[22px] lg:font-normal lg:leading-7 lg:text-[var(--Schemes-On-Surface,#1B1C1D)]",
]);

export const registrationFeedbackThankYouActionsStyles = cva([
  "box-border flex w-full min-w-0 max-w-full flex-col items-stretch",
  "lg:max-w-[320px] lg:self-center",
]);

/** Figma M3 filled round medium: state-layer px-24 py-16 → 56px total height. */
export const registrationFeedbackThankYouCloseButtonStyles = cva([
  "py-4 px-6 font-[Poppins,sans-serif] text-base font-medium leading-6 tracking-[0.15px]",
]);
